import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(SplitText, ScrollTrigger);

const stSplit = () => {

    const animation = document.querySelectorAll('[data-animation="split"]');
    if(!animation) return;

    animation.forEach((element) => {
        const split = new SplitText(element, {type: 'lines'});

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: 'top bottom-=8%',
                delay: 0.25
            },
            onComplete: () => {
                split.revert();
            }
        });

        tl
        .from(split.lines, {
            autoAlpha: 0,
            y: 50,
            duration: 1.5,
            ease: 'power4.out',
            stagger: 0.15,
            clearProps: 'all'
        });
    });

}

export { stSplit }